import React from 'react';
import PropTypes from 'prop-types';
import { toggleDoNotDisturb } from '../actions/creators';
import Toggle from "shared/react_components/Toggle";

export default class MenuHeader extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    doNotDisturbEnabled: PropTypes.bool
  };

  handleClickDoNotDisturb() {
    this.props.dispatch(toggleDoNotDisturb(this.props.doNotDisturbEnabled));
  }

  render() {
    const doNotDisturbEnabled = this.props.doNotDisturbEnabled;
    return (
      <div className="notification-dropdown__header" data-mount="menu-header">
        <span className="notification-dropdown__title" data-attribute="title">Notifications</span>
        <div className="notification-dropdown__do-not-disturb" data-mount="do-not-disturb">
          <Toggle
            onClick={() => this.handleClickDoNotDisturb()}
            initialToggle={doNotDisturbEnabled}
            leftLabel={"Mute"}
          />
        </div>
      </div>
    );
  }
}
